<template>
  <a-card :bordered="false">
    <app-warp :title="activeKey==1?'会员中心':'会员信息'" :color='form.pageBgColor'>
      <template #app-sider-left>
        <div class="moduleContent" style="margin-right:20px">
          <div class="moduleTitle">组件库</div>
          <div class="navs">
            <div class="navs-group">
              <div v-for="(value,index) in modules" :key="index" >
                <div class="title">{{value.title}}</div>
                <div class="navs-components " :class='pageSet.items.find(v=> v.type == "task") ? "jinzhi":""'>
                  <nav class="special" v-for="(item,key) in value.modules" :key="key" :class='pageSet.items.find(v=> v.type == "task") ? "huise":""' @click="addModule(item)"
                    :hidden='item.hidden' >
                    <p class="item-icon">
                      <component v-if='item.icon' :is="item.icon"></component>
                    </p>
                    <p>{{item.name}}</p>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #app-content>
        <div class="s_po_re" v-if="activeKey==1">
          <img class="width100" style="position: absolute;top: 0;left: 0;" :src="form.pageBgImg?info.picdomain+form.pageBgImg:require('@/assets/images/user/bg.png')" alt="">
          <div class="s_po_re p-b-15">
            <div class=" p-l-20 p-r-10 p-t-50">
              <div class="s_po_re">
                <img class="width55" src="@/assets/images/user/top.png" alt="">
                <div class="s_po_ab_tl p-l-70 p-t-5">
                  <p class="fz-16" :style="'color:'+form.nickname_color">昵称</p>
                  <p class="m-t-5" :style="'color:'+form.nickname_color">会员ID：00001</p>
                </div>
              </div>
            </div>
          </div>
          <transition-group appear tag="div">
            <template v-for="(item,key) in pageSet.items" :key="key">
              <div class="app-module" @click.stop="activeModule(item.type,key)"
                :class="moduleIndex==key?'app-active-module':''" @dragstart="dragstart(item,key)"
                @dragenter="dragenter(item,key)" @dragend="dragend(item)" draggable="true">
                <component :is="item.type" :data="item" />
                <div class="app-module-del" @click.stop="delMoudle(key)" :hidden='item.noDel'>
                  <DeleteOutlined style="font-size:18px;color:#EFC58D" />
                </div>
              </div>
            </template>
          </transition-group>
        </div>
        <!-- 资料收集 -->
        <div class="s_po_re s_bf p-t-10 p-l-20 p-r-20 p-b-30" style="min-height:100%" v-if="activeKey==2">
            <perfect :formInfo="formInfo" ref="myConfig" :key="1" v-show="formInfo.status==1" @change="getCheckList()"></perfect>
            <div v-show="formInfo.status==0" style="width:100%;height:100%;textAlign:center;lineHeight:40px;background:#252531;color:#fff;">
              <ExclamationCircleOutlined class="m-r-5"/>暂未开通会员信息收集</div>
        </div>
      </template>
      <template #app-sider>
        <!-- 基础配置 -->
        <a-tabs v-model:activeKey="activeKey" style="marginLeft:30px" @change="changeActive">
          <template v-slot:tabBarExtraContent>
            <span class='mr15'>
              <a-button type="primary" ghost @click="getMemberLink">
                会员中心地址
              </a-button>
            </span>
          </template>
          <a-tab-pane :key="1" tab="基础配置">
              <div class="moduleContent " style="width:100%;">
              <a-form :model="form" ref='ruleForm' :label-col="{span:4}" :wrapper-col="{span:18}">
                <p  class="moduleTitle m-b-20 p-b-5">页面管理</p>
                <a-form-item label="页面背景图" help='会员中心页面顶部背景图，图片建议尺寸750*484，大小1M以内'>
                  <material :groupType='1' :image="form.pageBgImg" :max="1"
                          v-on:handlechoose="(data)=>{form.pageBgImg=data}" v-on:handledel="form.pageBgImg=''" />
                </a-form-item>
                <a-form-item label="页面背景色" help='会员中心页面整体背景色，建议与背景图底部颜色一致'>
                  <a-input v-model:value="form.pageBgColor" type="color"  style="width:300px"/>
                </a-form-item>
                <a-form-item label="会员信息" help='会员昵称、会员ID字体颜色'>
                  <a-input v-model:value="form.nickname_color" type="color"  style="width:300px"/>
                </a-form-item>
                <div class="m-t-20" v-if='pageSet.items.length'>
                  <div class="moduleTitle m-b-20 p-b-5" v-if='moduleIndex!==-1'>{{modelRef["items"][moduleIndex]["name"]}}</div>
                  <template v-for="(value,index) in formCreateData" :key="value">
                    <a-form-item :label="value.label" :help="value.help">
                      <!-- 文本域 -->
                      <template v-if="value.stamp=='textarea'">
                        <a-textarea v-model:value="modelRef['items'][moduleIndex][value.key][value.name]" :rows="4"
                          :help="value.help" />
                      </template>
                      <!-- 普通表单 -->
                      <template v-if="value.stamp=='input'">
                        <a-input v-model:value="modelRef['items'][moduleIndex][value.key][value.name]" :type="value.type"  style="width:300px"
                          :help="value.help" />
                      </template>
                      <!-- 渐变 -->
                      <template v-if="value.stamp=='gpickr'">
                        <a-input class="width50" v-model:value="modelRef['items'][moduleIndex][value.key][value.name].left"  style="width:150px"
                          :type="value.type" :help="value.help" />
                        <a-input class="width50" v-model:value="modelRef['items'][moduleIndex][value.key][value.name].right"
                          :type="value.type" :help="value.help"  style="width:150px" />
                      </template>
                      <!-- 单选框 -->
                      <template v-if="value.stamp=='radio'">
                        <a-radio-group :options="value.options"
                      v-model:value="modelRef['items'][moduleIndex][value.key][value.name]" />
                  </template>
                  <!-- 复选框 -->
                  <template v-if="value.stamp=='checked'">
                    <a-checkbox v-model:checked="modelRef['items'][moduleIndex][value.key][value.name]"></a-checkbox>
                  </template>
                  <!-- 开关 -->
                  <template v-if="value.stamp=='switch'">
                    <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="modelRef['items'][moduleIndex][value.key][value.name]" >
                      <template #checkedChildren>{{value.open}}</template>
                      <template #unCheckedChildren>{{value.close}}</template>
                    </a-switch>
                  </template>
                  <!-- 复选框组 -->
                  <template v-if="value.stamp=='checkeds'">
                    <a-checkbox v-for="(items,indexs) in modelRef['items'][moduleIndex].data" :key='indexs'
                      v-model:checked="items['show']"
                      :disabled="modelRef['items'][moduleIndex].data.filter(v=>v['show']).length == 2 && items['show']">
                      {{items['name']}}</a-checkbox>
                  </template>
                  <!-- 单图片上传 -->
                  <template v-if="value.stamp=='singleImage'">
                    <material :groupType='1' :image="modelRef['imgUrl']" :max="1"
                      v-on:handlechoose="(data)=>{modelRef['imgUrl']=data}" v-on:handledel="modelRef['imgUrl']=''" />
                  </template>
                  <!-- 滑动 -->
                  <template v-if="value.stamp=='slider'">
                    <a-slider :tip-formatter="(value)=>value+'px'"
                      v-model:value="modelRef['items'][moduleIndex][value.key][value.name]"  style="width:300px"/>
                  </template>
                  <!-- 图片上传 -->
                  <template v-if="value.stamp=='image'">
                    <div v-for="(items,indexs) in modelRef['items'][moduleIndex].data" :key="indexs+value.stamp"
                      class="imagesContent">
                      <a-form-item label="图片" :label-col="{span:4}" :wrapper-col="{span:17}" style='margin-bottom: 0;'>
                        <material :groupType='1' :image="items['imgUrl']" :max="1"
                          v-on:handlechoose="(data)=>{items['imgUrl']=data}" v-on:handledel="items['imgUrl']=''" />
                      </a-form-item>
                      <a-form-item label="链接地址" :label-col="{span:4}" :wrapper-col="{span:17}" style='margin-bottom: 0;'>
                        <!-- <a-input v-model:value="items['linkUrl']" /> -->
                        <a-input-search v-model:value="items['linkUrl']" @search="onChooseLink(moduleIndex,indexs)"
                          readonly>
                          <template #enterButton>
                            <a-button type="primary">
                              选择
                            </a-button>
                          </template>
                        </a-input-search>
                      </a-form-item>
                      <CloseOutlined class="images_del" @click="delImagesData(indexs)" />
                    </div>
                    <a-button type="primary" @click="addImagesData(index,active)">
                      添加一个
                    </a-button>
                    <span class="s_c999">（为了页面美观，推荐上传统一的图片尺寸）</span>  
                  </template>
                  <!--会员权益-->
                  <template v-if="value.stamp=='privilege'">
                    <div class="s_flex_ali s_flex_wrap" style="background: #f7fafc;">
                      <template v-for="(items,indexs) in modelRef['items'][moduleIndex][value.key]" :key="indexs+value.stamp">
                        <div :hidden="items['hidden']" class="width25 p-t-10 m-b-10">
                          <div class="width-104 height-104 s_over s_mauto">
                            <material :groupType='1' :image="items['imgUrl']" :max="1"
                              v-on:handlechoose="(data)=>{items['imgUrl']=data}" v-on:handledel="items['imgUrl']=''" />
                          </div>
                          <div class="s_flex_center">
                            <a-checkbox v-if="items['checkout']" v-model:checked="items['show']" :disabled='items["disabled"]'></a-checkbox>
                            <p :class="items['checkout'] ? 'p-l-5':''">{{items['name']}}</p>
                          </div>
                          <div class="width90 s_mauto">
                            <a-button type="primary" block size='small' @click="items['imgUrl']=''">使用默认图标</a-button>
                          </div>
                        </div>
                      </template>
                    </div>
                  </template>
                </a-form-item>
              </template>
            </div>
          </a-form>
        </div>
        </a-tab-pane>
        <!-- 资料收集 -->
          <a-tab-pane :key="2" tab="资料收集" force-render>
              <div class="moduleContent " style="width:100%;">
                <a-form :model="formInfo" ref='ruleForm' :label-col="{span:4}" :wrapper-col="{span:18}">
                  <p  class="moduleTitle m-b-20 p-b-5">资料收集配置</p>
                  <a-form-item label="完善会员信息">
                    <a-radio-group v-model:value="formInfo.status">
                      <a-radio :value="1">开启</a-radio>
                      <a-radio :value="0">关闭</a-radio>
                    </a-radio-group>
                  </a-form-item>
                  <a-form-item label="标题文字" v-show="formInfo.status==1">
                    <a-input v-model:value="formInfo.title" type="text"  style="width:260px" placeholder="输入标题"/>
                  </a-form-item>
                  <a-form-item label="送积分" v-show="formInfo.status==1">
                    <a-input-number v-model:value="formInfo.point" type="text"  style="width:160px" placeholder="积分"/>
                  </a-form-item>
                    <a-form-item label="适用会员等级" v-show="formInfo.status==1" >
                      <a-radio-group v-model:value="formInfo.use_level">
                      <a-radio :value="0">全部会员等级</a-radio>
                      <a-radio :value="1">指定等级会员</a-radio>
                      </a-radio-group>
                      <br>
                      <a-select v-model:value="formInfo.leve" style="width:240px" class="m-t-10" placeholder="选择会员卡" v-show="formInfo.use_level==1">
                        <a-select-option :value="item.vip_number" v-for="(item,index) in memberVipList" :key="index">{{item.vip_name}}</a-select-option>
                        <!-- <a-select-option :value="2">黄金</a-select-option> -->
                      </a-select>
                    </a-form-item>
                    <a-form-item label="资料字段" v-show="formInfo.status==1" >
                      <a-checkbox-group v-model:value="configSelect" name="checkboxgroup"  :options="options" @change="checkboxChange"/>
                      <span style="color:#05486A;" class="m-l-5 s_shou" @click="myConfig.getConfigData()">字段管理</span>
                    </a-form-item>
                    <a-form-item label="温馨提示" v-show="formInfo.status==1" >
                        <a-input v-model:value="formInfo.tips" type="text"  style="width:260px" placeholder="输入温馨提示" maxlength="30"/>
                    </a-form-item>
                </a-form>
              </div>
          </a-tab-pane>
        </a-tabs>
        <!-- 基础配置 -->
        <a-button type="primary" v-has:setMemberCenter="onSubmit" class='m-l-30 m-t-10 m-r-10' v-if="activeKey==1">
          保存
        </a-button>
        <!-- 资料收集 -->
        <a-button type="primary" v-has:setMemberCenterInfo="onSubmitInfo" class='m-l-30 m-t-10 m-r-10' v-if="activeKey==2">
          保存
        </a-button>
      </template>
    </app-warp>
  </a-card>

   <!-- 登录地址 -->
  <a-modal  :keyboard="false" title="复制链接" centered :width='600' :footer="null" v-model:visible="visibleUrl" destroyOnClose>
    <div class="s_flex_bian_c">
      <div class="s_bor_r_cd9 p-r-20">
        <img class="width-160 height-160" :src="link.image" alt="">
        <p class="text-ac m-t-10">微信扫一扫立即预览</p>
      </div>
      <div class="width63">
        <p class="s_c333 s_font_b fz-16">复制地址</p>
        <div class="m-t-15 m-b-15 s_flex_bian_c">
          <a-input class="width80" v-model:value="link.link" readonly></a-input>
          <a-button type="primary" ghost @click="copy(link.link)">复制</a-button>
        </div>
        <p class="s_c999 ">此链接适用于H5环境，请谨慎用于微信小程序，否则容易引起数据异常</p>
      </div>
    </div>
  </a-modal>
</template>
<script>
  import * as Icon from "@ant-design/icons-vue";
  import banner from "./components/banner/index";
  import distribute from './components/distribute/index'
  import windows from "./components/windows/index";
  import nav from "./components/nav/index";
  import task from "./components/task/index";
  import assets from "./components/assets/index";
  import module from "./components/module/index";
  import receive from "./components/receive/index";
  import share from "./components/share/index";
  import { inject, nextTick, onMounted, reactive, ref, toRaw, toRefs } from "vue";
  import forms from "../memberSet/components/js/form";
  import modules from "../memberSet/components/js/modules"; //基础组件数据
  import store from "@/store";
  import { message } from 'ant-design-vue';
  import { getMemberCenter, setMemberCenter,configShow,customizes,updateConfig,getMemberVip,loginAddress } from '@/api/member'
  import { iscode } from '@/utils/app';
  import perfect from './components/perfectInfo/perfect'
  import { getClientsite } from "@/api/public";
  export default {
    components: { ...Icon, banner, nav, windows, task, assets, module,receive,share,perfect,distribute },
    setup() {
      const myConfig = ref(null);
      const state = reactive({
        form: {
          pageBgColor:'#252531',
          pageBgImg:'',
          nickname_color:'#fff'
        },
        info: store.state.user.info,
        linkVisible: false,
        taskVisible:false,
        modules,
        active: "", // 默认选中的类型、
        activeKey:1,
        moduleIndex: -1,
        visibleUrl:false,
         link: {
          image: "",
          link: "",
        },
        pageSet: { 
          items: [
            {
              type: 'assets',
              name: '会员卡组件配置',
              noDel: true,
              data: [
                { name: '积分', show: true }, { name: '卡券', show: true }, { name: '红包', show: true },
              ],
              params: [
                { name: '生日礼包', imgUrl: ""}, 
                { name: '免邮特权', imgUrl: "",hidden:true }, 
                { name: '产品特权', imgUrl: ""}, 
                { name: '扫码特权', imgUrl: ""}, 
                { name: '折扣特权', imgUrl: ""},
                { name: '礼品特权', imgUrl: ""}
              ],
              style: {
                color: '#EFC58D',
                bgColor: {
                  left: '#303145',
                  right: '#44495E'
                },
                assetsBgColor: '#484D62',
                show: true,
                privilegeTitle: '会员权益',
                grandTitle:"累计红包"
              }
            },
            {
              type: 'share',
              name: '分享特权',
              noDel: true,
              data: [],
              params: {},
              style:{
                shareTitle: '分享特权',
                color:'#EFC58D',
                bgColor:{
                  left:'#303145',
                  right:'#44495E'
                },
              }
            },
            {
              type: 'receive',
              name: '礼品评鉴',
              noDel: true,
              data: [],
              params: {},
              style:{
                receiveTitle: '礼品评鉴',
                color:'#EFC58D',
                bgColor:{
                  left:'#303145',
                  right:'#44495E'
                },
              }
            },
            {
              type: 'distribute',
              name: '礼品派发',
              noDel: true,
              data: [],
              params: {},
              style:{
                distributeTitle: '礼品派发',
                color:'#EFC58D',
                bgColor:{
                  left:'#303145',
                  right:'#44495E'
                },
                nextbgColor:{
                  left:'#37384D',
                  right:'#4C5062'
                }
              }
            },
            {
              type: 'module',
              name: '功能模块',
              noDel: true,
              data: [
                { name: '我的奖品', imgUrl: "",checkout:true,show:true,disabled:true },
                { name: '扫码奖品', imgUrl: "",checkout:true,show:true,disabled:true },
                { name: '订单', imgUrl: "",checkout:true,show:true,disabled:true },
                // { name: '云店', imgUrl: "",checkout:true,show:true },
                { name: '积分商城', imgUrl: "",checkout:true,show:true },
                { name: '权益卡', imgUrl: "",checkout:true,show:true }
              ],
              params: {},
              style:{
                show: false,
                moduleTitle: '功能模块',
                color:'#EFC58D',
                bgColor:{
                  left:'#303145',
                  right:'#44495E'
                },
              }
            },
          ],
        },
        formInfo:{
          status:0,
          use_level:0,
          leve:null,
          field:[],
          point:'',
          title:'',
          tips:'生日一经填写就不能修改，请注意',
          name:'',
          phone:''
        },
        options:[],
        configCheckList:[], //字段列表
        configSelect:[], //选中的字段
        memberVipList:[]
      });
      const $route = inject('$route')
      const $router = inject('$router')
      // 获取详情
      var modelRef = ref(state.pageSet);
      onMounted(() => {
        getCheckList()
        getMore();
        getConfig()
        getMemberVipList()
        
      })
      const getMore = async () => {
        let result = await getMemberCenter().then(res => res.data).catch(error => error)
        if(result.data.content ){
          var content = result.data.content 
          state.form.nickname_color = result.data.nickname_color
          state.form.pageBgColor = result.data.page_bg_color
          state.form.pageBgImg = result.data.page_bg_img
          if(content.items.length){
            state.pageSet = content;
            modelRef.value=state.pageSet;
          }
        }
        formCreate();
      }
      const ruleForm = ref()
      // 读取模块表单数据
      var formCreateData = ref({});
      const formCreate = () => {
        forms.forEach((element) => {
          // console.log(element,'查看')
          if (element.type == state.active) {
            formCreateData.value = element.formItems;
             console.log(element,'查看')
          }
        });
      };
      // 激活模块
      const activeModule = (type, index) => {
        // console.log(type)
        state.active = type;
        state.moduleIndex = index;
        modelRef.value["items"][index] = state.pageSet.items[index]
        formCreate();
      };
      // 追加模块
      const addModule = (item) => {
        modelRef.value.items.push(item.defaultData);
        state.active = item.type;
        activeModule(item.type, state.pageSet.items.length - 1)
      };
      // 移除模块
      const delMoudle = (index) => {
        state.pageSet.items.splice(index, 1);
        var items = state.pageSet.items
        if (items.length) {
          activeModule(items[items.length - 1].type, items.length - 1)
        } else {
          activeModule('page', -1)
        }
      };
      // 轮播图开始----------------------------
      // 追加图片数据
      const addImagesData = (index) => {
        if (modelRef.value.items[state.moduleIndex].data.length == 5 && state.active == 'module') {
          message.error('最多可添加5个功能列表')
          return
        }
        modelRef.value.items[state.moduleIndex].data.push({ imgUrl: "",linkType: "" , linkUrl: "" });
      };
      // 删除轮播图片数据
      const delImagesData = (index) => {
        if (modelRef.value.items[state.moduleIndex].data.length == 1) {
          message.error('至少要存在一个图片配置')
        } else {
          modelRef.value.items[state.moduleIndex].data.splice(index, 1)
        }
      }
      // 轮播图结束----------------------------
      // 保存当前模版数据
      const onSubmit = () => {
        ruleForm.value.validate().then(async (e) => {
          let data = { ...state.form, content: JSON.stringify(state.pageSet) }
          var result = await setMemberCenter(data).then(res => res.data).catch(error => error)
          if (iscode(result, true)) {
            state.moduleIndex = -1
            state.active = ''
            formCreateData.value = {}
            getMore();
          }
        }).catch(error => {
          message.error('请完善表单！')
        })
      };
      // 拖动模块顺序
      // 记录初始信息
      const start_index = ref(0)
      const end_index = ref(0)
      const dragstart = (value, index) => {
        start_index.value = index;
      }
      // 做最终操作
      const dragend = (value) => {
        let oldValue = state.pageSet.items[start_index.value]
        let newValue = state.pageSet.items[end_index.value]
        let newItems = [...state.pageSet.items];
        newItems[start_index.value] = newValue
        newItems[end_index.value] = oldValue
        // this.items一改变，transition-group就起了作用
        state.pageSet.items = [...newItems];
        activeModule(value.type, end_index.value)
      }
      // 记录移动过程中信息
      const dragenter = (value, index) => {
        end_index.value = index
      }
      // 选择链接地址
      // 
      var father = ref(0)
      var children = ref(0)
      const onChooseLink = (findex, index,text) => {
        father.value = findex
        children.value = index
        if(text){
          state.taskVisible = true
        }else{
          state.linkVisible = true
        }
        
      }
      // 选择链接
      const selecLink = (link) => {
        if (!link) return
        if (children.value == -1) {
          modelRef.value['items'][father.value].params.link = link
        } else {
          modelRef.value['items'][father.value].data[children.value].linkUrl = link.url
          modelRef.value['items'][father.value].data[children.value].linkType = link.type
        }
        state.linkVisible = false
      }
      const taskSelect = (e) =>{
        modelRef.value['items'][father.value].data[children.value] = e
        state.taskVisible = false
      }

      // 获取会员中心地址--参数有误
      const getMemberLink = async (client_type) => {
        let result = await getClientsite({client_type:4}).then((res) => res.data).catch((error) => error);
        state.link = result.data;
        state.visibleUrl = true;
      };

     // 复制
      const copy = (link) => {
        var input = document.createElement("input"); // 直接构建input
        input.value = link; // 设置内容
        document.body.appendChild(input); // 添加临时实例
        input.select(); // 选择实例内容
        document.execCommand("Copy"); // 执行复制
        document.body.removeChild(input); // 删除临时实例
        message.success("复制成功");
      };
      //选中字段
      const checkboxChange = function(e){

        // state.formInfo.field = e;
        state.configSelect = e;
        if(e.length!=0){
            let configArr =[];
            e.forEach(item=>{
              configArr.push(state.configCheckList[item])
            })
            myConfig.value.setConfigForm(configArr)
        }else{
           myConfig.value.setConfigForm([])
        }
       
      }

      const getConfig =async function(){
       let res = await configShow().then(res=>res.data);
       if(iscode(res)){
         state.formInfo = res.data || {};
         state.configSelect = res.data.field.map(item=>{
           return item.id
         })
        //  console.log(state.configSelect,11)
       }else{
         message.error(res.msg);
       }
     }
     //字段列表
     const getCheckList =async function(){
         let res = await customizes().then(res=>res.data);
          if(iscode(res)){
            let arr = []
             res.data.forEach((item)=>{
              if(item.is_enable==1){
                 arr.push({
                    'label':item.customize_name,
                    'value':item.id,
                 })
                 state.configCheckList[item.id] = item;
               }
            });
             state.options = arr;
           }else{
             message.error(res.msg);
           }
     }
     //tabs
     const changeActive = function(e){
        console.log(e)
        if(e==2){ //资料收集
           nextTick(()=>{
            state.configSelect = state.formInfo.field.map(item=>item.id)
            myConfig.value.setConfigForm(state.formInfo.field)
           })
        }
     }

     const onSubmitInfo = async function(){
         const hide = message.loading("正在加载中...", 0);
          let configArr = [];
          state.configSelect.forEach(item=>{
              configArr.push(state.configCheckList[item])
          })
          const content = JSON.stringify({...state.formInfo,field:configArr})
         let res = await updateConfig({content:content}).then(res=>res.data);
         setTimeout(hide);
         if(iscode(res)){
            message.success(res.msg);
            getConfig()
         }else{
            message.error(res.msg);
         }
     }
     //会员列表
     const  getMemberVipList = async function(){
        let res = await getMemberVip().then(res=>res.data);
        if(iscode(res)){
          state.memberVipList = res.data || [];
        }else{
          message.error(res.msg);
        }
     }

      return {
        ...toRefs(state),
        modelRef,
        onSubmit,
        formCreateData,
        activeModule,
        addModule,
        delMoudle,
        addImagesData,
        delImagesData,
        dragenter,
        dragend,
        dragstart,
        onChooseLink,
        ruleForm,
        selecLink,
        taskSelect,
        copy,
        getMemberLink,
        checkboxChange,
        myConfig,
        getConfig,
        getCheckList,
        changeActive,
        onSubmitInfo
      };
    },
  };
</script>
<style lang="less" scoped>
  .huise{
    opacity: .5;
    pointer-events: none;
  }
  .jinzhi{cursor:not-allowed;}
  .moduleContent {
    width: 285px;
    min-height: 600px;
    height: auto;
    background: #fdfdfd;
    border: 1px solid #ddd;
    padding: 15px 10px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    user-select: none;

    .moduleTitle {
      position: relative;
      padding-left: 22px;
      line-height: 30px;
      font-weight: 600;
      border-bottom: 1px solid #eef1f5;

      &::before {
        content: "";
        position: absolute;
        width: 4px;
        height: 13px;
        background: #204736;
        top: 10px;
        left: 9px;
      }
    }

    .navs {
      padding: 10px 5px;
      border-bottom: 1px dotted #ddd;
      position: relative;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;

      .navs-group {
        display: block;
        width: 100%;

        .title {
          font-size: 0.24rem;
          color: #999;
          margin: 10px 0;
        }

        .navs-components {
          display: flex;
          flex-wrap: wrap;
        }

        .special {
          background: #f4f4f4;
          width: 74px;
          padding: 3px 0;
          margin: 5px;
          border: 1px solid #dddddd;
          text-align: center;
          font-size: 12px;
          cursor: pointer;
        }

        p {
          color: #424242;
          font-size: 12px;
        }
      }
    }
  }

  .app-module {
    position: relative;
    border: 2px dashed transparent;

    &:hover {
      border: 2px dashed #f04635 !important;

      .app-module-del {
        display: block;
      }
    }

    .app-module-del {
      z-index: 100;
      display: none;
      position: absolute;
      right: 2px;
      bottom: 2px;
      color: #204736;
      font-size: 12px;
    }
  }

  .app-active-module {
    border: 2px dashed #f04635 !important;
  }

  .imagesContent {
    padding: 20px;
    background: #f7fafc;
    position: relative;
    border-radius: 3px;
    cursor: move;
    margin-bottom: 20px;

    .images_del {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
    }
  }

  .navContent {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;

    .images_del {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
    }
  }

  .taskContent {
    padding: 20px;
    background: #f7fafc;
    position: relative;
    border-radius: 3px;
    cursor: move;
    margin-bottom: 20px;

    .images_del {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
    }
  }

</style>